module.exports = __webpack_public_path__ + "img/img_001@2x.f8053afd.png";